import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'components/common';

export default connect((state) => state)(
  class extends Component {
    state = {
      hasPrevious: false,
      hasNext: false
    };

    componentDidMount = () => {
      window.addEventListener('message', this.updateScormStatus);
    };

    componentWillUnmount = () => {
      window.removeEventListener('message', this.updateScormStatus);
    };

    updateScormStatus = (event) => {
      if (parseInt(event.data.blockId) !== this.props.blockId) {
        return;
      }

      if (event.data && event.data.hasNext) {
        if (event.data.hasNext === 'true') {
          this.setState({ hasNext: true });
        }
        if (event.data.hasNext === 'false') {
          this.setState({ hasNext: false });
        }
      }
      if (event.data && event.data.hasPrevious) {
        if (event.data.hasPrevious === 'true') {
          this.setState({ hasPrevious: true });
        }
        if (event.data.hasPrevious === 'false') {
          this.setState({ hasPrevious: false });
        }
      }
    };

    scormSetPrevious = () => {
      this.scormApiRequest('previous');
    };

    scormSetContinue = () => {
      this.scormApiRequest('continue');
    };

    scormApiRequest = (value) => {
      document.getElementById(this.props.iframeKey).contentWindow.postMessage(
        {
          varname: 'adl.nav.request',
          value: value,
          blockId: this.props.blockId
        },
        '*'
      );
    };

    render() {
      const { messages, theme } = this.props;
      return (
        <div
          style={{
            position: 'absolute',
            left: 10,
            bottom: 38,
            height: 0,
            width: '100%',
            padding: '0',
            textAlign: 'center'
          }}
        >
          <Button
            category="lighter"
            data-tooltip={messages.editorBlockEmbedSCORMPrevious}
            icon="arrow-left"
            onClick={this.scormSetPrevious.bind(this)}
            size="huge"
            style={{
              width: '32px',
              height: '32px',
              padding: '0',
              margin: '2px',
              visibility: this.state.hasPrevious ? 'visible' : 'hidden'
            }}
          />
          <Button
            category="lighter"
            data-tooltip={messages.editorBlockEmbedSCORMContinue}
            icon="arrow-right"
            onClick={this.scormSetContinue.bind(this)}
            size="huge"
            style={{
              width: '32px',
              height: '32px',
              padding: '0',
              margin: '2px',
              visibility: this.state.hasNext ? 'visible' : 'hidden'
            }}
          />
        </div>
      );
    }
  }
);
